import React, { useState, useEffect } from 'react';
import { formFieldTypes, resources } from '../../constants.js';
import { getWordWithCorrectEnding, loadAvatar } from '../helpers/HelperFunctions.js';

const DocumentItemField = (props) => {
    const [imgUrl, setImgUrl] = useState('');

    useEffect(() => {
        if (props.settings.type === formFieldTypes.user && props.field.props?.login) {
            loadAvatar(props.field.props.login, props.field.props.avatarId).then(url => {
                setImgUrl(url ?? resources.defaulUserImg);
            });
        }
    }, []);

    const getItemContent = () => {
        if (props.field.value) {
            switch (props.settings.type) {
                case formFieldTypes.user:
                    return (<div className="item-content user" key="item-content">
                        {imgUrl && <img src={imgUrl} />}
                        {props.field.value}
                    </div>);
                case formFieldTypes.state:
                    return (<div className="item-content state" key="item-content">
                        {props.field.value}
                    </div>);
                case formFieldTypes.dateInterval:
                    return (<div className="item-content date-interval" key="item-content">
                        {props.field.value}
                    </div>);
                case formFieldTypes.daysCount:
                    return (<div className="item-content days-count" key="item-content">
                        {props.field.value}&nbsp;{getWordWithCorrectEnding(props.field.value, 'день')}
                    </div>);
                default:
                    return (<div className="item-content" key="item-content">
                        <div className="value">{props.field.value}</div>
                    </div>);
            }
        }
    }

    return (<div className="item" key={props.field.name} >
        {props.settings.label && <div className="label" key="label">{props.settings.label}:&nbsp;</div>}
        {getItemContent()}
    </div>)
}

export default DocumentItemField;